module.exports = __webpack_public_path__ + "img/fd2b110.svg";